import { Klass, u_, csl } from "@pressmedia/webappbase";

/*******************************
* define Klass InstagramModule *
*******************************/
Klass.create("InstagramModule").extends_("TyrellModule", {
	_initialize(opt) {
		const _super_ = Klass("InstagramModule").parent._initialize;
		_super_.call(this, "instagram", opt);
		
		if( !u_.isFunction(this.errorCallbacks.WARNING) ) {
			this.errorCallbacks.WARNING = this.warningCallback;
		}
		
		return this;
	},
	
	warningCallback(messages, methodName, errcode, errtype) {
		csl.warn(`${errtype} (${errcode})`, { methodName, messages });
		return this;
	},
	
	async getRecent(limit, callback) {
		const methodName = "getRecent";
		u_.isFunction(limit) && (callback = limit);
		
		const data = u_.isInteger(limit) ? { limit } : null;
		
		const res = await this._sendRequest(methodName, { data }, callback);
		
		const { error, response } = res;
		if(!error) {
			const { items } = response;
			if( Array.isArray(items) ) {
				const hasItemFilter = u_.isFunction(this.itemFilter);
				
				this.items.list = items.map((item, i) => {
					u_.hasProperty(item, "index") || (item.index = i);
					hasItemFilter && this.itemFilter(i, item);
					return item;
				});
				
				this.items.length = this.items.list.length;
			}
		}
		
		return res;
	}
});
